import { NgModule } from '@angular/core';
import { FlightPreferenceFormService } from './flight-preference-form.service';
import { FlightPreferenceFormComponent } from './flight-preference-form.component';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { DxCheckBoxModule } from 'devextreme-angular';
import { ModalWindowModule } from 'ag-common-svc/lib/components';
import { AirlinePreferenceFormModule } from './components/airline-preference-form/airline-preference-form.module';
import { FlightPreferencePipesModule } from './pipes/flight-preference-pipes.module';

@NgModule({
  declarations: [FlightPreferenceFormComponent],
  imports: [
    SharedModule,
    DxCheckBoxModule,
    ModalWindowModule,
    AirlinePreferenceFormModule,
    FlightPreferencePipesModule,
  ],
  exports: [FlightPreferenceFormComponent],
  providers: [FlightPreferenceFormService],
})
export class FlightPreferenceFormModule {}
